import React from 'react'
import { ADMIN_ACTION } from "../../constants/common"

const AdminHistoryTab = ({ adminHistory }) => {
    const adminAction = ADMIN_ACTION;
    const convertToDecimalHour = (dateString) => {
        const date = new Date(dateString);
        const hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${hours}:${minutes}`;
    };
    return (
        <div className='founder-admin-history'>
            <div className='founder-history-section'>
                {adminHistory.length > 0 &&
                    <div className="history-list">
                        {
                            adminHistory?.map((item, index) => {
                                return <div className='history-list-card' key={index}>
                                    <div className='card-description'>
                                        <div className="list-name">
                                            {adminAction?.find(action => action?.key === item?.actionType)?.value || item?.actionType}
                                            : {item?.actionType === "RESTORED" || item?.actionType === "SUSPENDED"
                                                ? item?.reason
                                                : item?.actionDetail
                                            }
                                        </div>
                                    </div>

                                    <div className='card-time'>
                                        {convertToDecimalHour(item?.updatedAt)}
                                    </div>
                                </div>
                            })
                        }
                    </div>
                }
            </div>
        </div>
    )
}

export default AdminHistoryTab